import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import type { UseErrorModalReturn } from '@percent/domain/giving'

export function UnexpectedErrorModal({
  isOpen,
  closeModal,
  errorMsg
}: Pick<UseErrorModalReturn, 'isOpen' | 'closeModal' | 'errorMsg'>) {
  const { t } = useTranslation()

  return (
    <Modal borderRadiiSize="xlarge" onClose={closeModal} open={isOpen}>
      <AcknowledgeModal
        result="negative"
        title={errorMsg ?? t('errorMessage.somethingWentWrong')}
        description={t('errorMessage.tryAgainLater')}
        buttonText={t('button.close')}
        handleClose={closeModal}
        buttonShape="oval"
      />
    </Modal>
  )
}
